"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareUrl = void 0;
const prepareUrl = (url, params = null) => {
    if (!params) {
        return url;
    }
    return Object.keys(params).reduce((acc, key) => {
        return acc.replace(`:${key}`, `${params[key]}`);
    }, url);
};
exports.prepareUrl = prepareUrl;
